import * as React from 'react'

import { Box, Button, Table } from '@factorialco/deprecated-design-system'

interface Props {
  addRowDisabled: boolean
  headers: string[]
  addRowButtonText: string
  emptyStateText: string
  handleAddRow: () => void
  children?: React.ReactNode
}

const TableWithEditableRows: React.FC<Props> = ({
  addRowDisabled,
  headers,
  addRowButtonText,
  emptyStateText,
  handleAddRow,
  children,
}) => {
  const isEmpty = !children || (Array.isArray(children) && children.length === 0)

  return (
    <Box gap="s16">
      <Table>
        <Table.Head>
          <Table.Row>
            <>
              {headers.map((header, index) => (
                <Table.HeadCell ellipsis wide key={index}>
                  {header}
                </Table.HeadCell>
              ))}
            </>
            <Table.HeadCell width={40} wide />
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isEmpty ? (
            <Table.Row>
              <Table.Cell colSpan={headers.length + 1}>
                <Box textAlign={'center'}>{emptyStateText}</Box>
              </Table.Cell>
            </Table.Row>
          ) : (
            <>{children}</>
          )}
        </Table.Body>
      </Table>
      <Box alignItems="flexStart">
        <Button onClick={handleAddRow} type="secondary" disabled={addRowDisabled} iconName="add">
          {addRowButtonText}
        </Button>
      </Box>
    </Box>
  )
}

export default TableWithEditableRows
